export default __webpack_public_path__ + "static/media/triumphantlifeofset.c9a9f9fd.png";